import { EmployeeReportState } from '../interface/EmployeeReportInterface'

export default function (state: EmployeeReportState = {}, action) {
    let propertyName: string;

    switch (action.type) {
        case "OPEN_ZOOM":
            propertyName = "showZoomed";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "CLOSE_ZOOM":
            propertyName = "showZoomed";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_REPORT_LOADING":
            return action.payload;

        case "EMPLOYEE_TAB1_BULLETS":
            propertyName = "EmployeeReport_Tab1";
            var newState = Object.assign({}, state);
            newState[propertyName].bullets = action.payload.bullets;
            newState[propertyName].destination_counts = action.payload.destination_counts;
            newState[propertyName].in_state_count = action.payload.in_state_count;
            newState[propertyName].year_first_left = action.payload.year_first_left;
            return newState;

            
        case "EMPLOYEE_TAB2":
            propertyName = "EmployeeReport_Tab2";
            var newState = Object.assign({}, state);
            newState[propertyName].min_year = action.payload.min_year;
            newState[propertyName].max_year = action.payload.max_year;
//            newState[propertyName].bullets = action.payload.bullets;
            return newState;

        case "EMPLOYEE_TAB2_BULLETS":
            var newState = Object.assign({}, state);
            newState["EmployeeReport_Tab2"].bullets = action.payload.bullets;
            return newState;


        case "EMPLOYEE_TAB_MATCHRATE":
            propertyName = "EmployeeReport_MatchRateTab";
            var newState = Object.assign({}, state);
            newState[propertyName].bullets = action.payload.bullets;
            return newState;

        case "EMPLOYEE_PROFILE_INFO":
            propertyName = "EmployeeProfileInfo";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_PROFILE_1":
            propertyName = "EmployeeProfile1";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_PROFILE_2":
            propertyName = "EmployeeProfile2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "EMPLOYEE_MATCH_RATE":
            propertyName = "EmployeeMatchRate";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "DOWNLOAD":
            return state;
        default:
            return state;
    }
}